import { Layout, Modal, Popover, Select } from "antd";
import { Content } from "antd/es/layout/layout";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Slider } from "@components/Slider";
import { Text } from "@components/Text";
import { useSocketContext } from "@contexts/socket/socketContext";
import { COLOR_BLACK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { MENU_SIZE, MODAL_SIZE } from "@static/SIZE";
import { exportPrediction } from "@utils/exportPrediction";
import { fetchAPI } from "@utils/https/fetchAPI";
import {
  generateTimeSlots,
  getMaxDuration,
  preprocessCampaigns,
  summarizeTimeSlots,
} from "@utils/prediction";

import { DeviceList } from "./DeviceList";
import { PopoverItem } from "./PopoverItem";
import { SummaryTable } from "./SummaryTable";

const SectionGroupAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const SectionContentLayout = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  height: calc(100% - 54px);
`;

const LayoutPrediction = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 16px;
  padding: 16px;
  gap: 8px;
  overflow: hidden;
`;

// wait for edit
const LayoutPredictionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
`;
// wait for edit

const LayoutLabelTimeSlot = styled.div`
  display: flex;
  min-width: fit-content;
  background: white;
  margin-bottom: 8px;
`;

const LabelTimeSlotItem = styled.div`
  display: flex;
  flex-shrink: 0;
  width: ${({ $width = 1 }) => $width}px;
  align-items: flex-start;
`;

const LayoutPredictionContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: scroll;
  background: #f9f7f8;
  border-width: 1px;
  border-color: #eeeeee;
  border-style: solid;
`;

const CampaignListBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  width: 100%;
`;
const ContainerBlockLabel = styled.div`
  padding: 2px 4px;
  background: white;
  width: fit-content;
  border-top-right-radius: 12px;
  box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
    rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
`;

const ContainerBlockList = styled.div`
  display: flex;
  flex-direction: column;
`;

const CampaignItem = styled.button`
  display: flex;
  flex-shrink: 0;
  height: 20px;
  padding: 0px;
  width: ${({ $width = 1 }) => $width}px;
  border-color: white;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  /* padding: 1px; */
  background: red;
`;

const ContainerLayoutSummary = styled.div`
  width: 25%;
  /* background: white; */
  /* border-radius: 16px; */
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const LayoutSummary = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  gap: 8px;
  background: white;
  padding: 8px 16px;
  overflow: hidden;
`;

// const ContainerTimeSlotDetails = styled.div`
//   width: 100%;
//   border-radius: 16px;
//   background: linear-gradient(181deg, #fff 50%, #e9fff9 99.52%);
// `;

const MAPPING_COLORS = {
  video: "#B5E48C",
  image: "#0C9",
  audio: "#1A759F",
  website: "#F3A11D",
  streaming: "#9C53B4",
  youtube: "#F41C0C",
  "running-text": "#997D00",
  nothing: "transparent",
};

const ContainerPopover = styled.div`
  display: inline-flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 0px 8px 8px 8px;
  background: linear-gradient(181deg, #fff 50%, #e9fff9 99.52%);
  box-shadow: 0px 4px 16px 0px #cccfdc;
`;

const ContainerFileName = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContainerDescription = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

const ContainerDescriptionItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export default () => {
  const socket = useSocketContext();
  const navigate = useNavigate();
  const params = useParams();
  const playerId = _.get(params, ["playerId"]);

  const [multiple, setMultiple] = useState(1);
  const [startWhen, setStartWhen] = useState(null);
  // const [startWhen, setStartWhen] = useState("00:00:00");

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    data: null,
  });

  const [selectedFilter, setSelectedFilter] = useState(null);

  const [timeSlots, setTimeSlots] = useState(null);
  const [labelTimeSlots, setLabelTimeSlots] = useState([]);
  const [renderTimeSlots, setRenderTimeSlots] = useState(null);

  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

  const [summaries, setSummaries] = useState(null);

  const [mediaListOptions, setMediaListOptions] = useState([]);

  const generateLabelTimeSlot = ({ startWhen = "00:00:00" }) => {
    const intervalSeconds = 15 * 60;
    const totalSecondsPerDay = 24 * 60 * 60;
    const [h, m, s] = startWhen.split(":").map(Number);
    let currentSec = h * 3600 + m * 60 + s;

    const slots = [];

    while (currentSec < totalSecondsPerDay) {
      const nextSlotEndSec =
        Math.ceil((currentSec + 1) / intervalSeconds) * intervalSeconds;
      const duration = Math.min(
        nextSlotEndSec - currentSec,
        totalSecondsPerDay - currentSec
      );
      const labelHour = Math.floor(currentSec / 3600);
      const labelMinute = Math.floor((currentSec % 3600) / 60);
      const label = `${_.padStart(labelHour, 2, "0")}:${_.padStart(
        labelMinute,
        2,
        "0"
      )}`;

      slots.push({ label, duration });

      currentSec += duration;
    }

    return slots;
  };

  const initial = async () => {
    try {
      console.log("initial :>> ");
      const resp = await fetchAPI({
        method: "post",
        path: "/api/v2/backoffice/get-prediction-play-list",
        data: { playerId: playerId },
      });
      console.log("resp :>> ", resp);
      if (_.get(resp, ["status"])) {
        const playlist = _.get(resp, ["result", "respCampaignList"]);
        console.log("playlist :>> ", playlist);

        const filterPlaylist = getMaxDuration({ playlist });
        const preprocess = preprocessCampaigns({ playlist: filterPlaylist });
        console.log("preprocess :>> ", preprocess);

        const listOptions = _.chain(preprocess)
          .flatMap("contents")
          .uniqBy("mediaName")
          .filter((item) => {
            return _.includes(["image", "audio", "video"], item?.type);
          })
          .map((item) => ({
            label: item?.mediaName,
            value: item?.mediaName,
          }))
          .value();

        setMediaListOptions(listOptions);
        console.log("listOptions :>> ", listOptions);
        const originTimeSlots = generateTimeSlots({
          processedCampaigns: preprocess,
          startTime: startWhen,
          // startTime: "00:00:00",
          endTime: "23:59:59",
          // endTime: "03:59:59",
        });
        console.log("originTimeSlots :>> ", originTimeSlots);
        const labelTimeSlot = generateLabelTimeSlot({ startWhen });
        setLabelTimeSlots(labelTimeSlot);
        // console.log("labelTimeSlot :>> ", labelTimeSlot);
        // console.log("originTimeSlots :>> ", originTimeSlots);
        setTimeSlots(originTimeSlots);
        setRenderTimeSlots(originTimeSlots);
        const summary = summarizeTimeSlots({ list: originTimeSlots });
        console.log("summary :>> ", summary);
        setSummaries(summary);
        // console.log("preprocess :>> ", preprocess);
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  useEffect(() => {
    if (!startWhen) {
      return;
    }
    initial();
  }, [startWhen]);

  const onHandleReceivedStartWhen = async ({ message }) => {
    setStartWhen(message);
  };

  useEffect(() => {
    if (!socket) {
      return;
    }

    socket.on(
      "SERVICE-SEND-START-WHEN-TO-BACK-OFFICE",
      onHandleReceivedStartWhen
    );
    socket.emit("BACK-OFFICE-REQUEST-ELECTRON-START-WHEN", {
      playerList: [playerId],
    });

    return () => {
      socket.off(
        "SERVICE-SEND-START-WHEN-TO-BACK-OFFICE",
        onHandleReceivedStartWhen
      );
    };
  }, [socket]);

  const handleSelectTimeSlot = ({ item }) => {
    const updateSelectedTimeSlot = _.isEqual(item, selectedTimeSlot)
      ? null
      : item;
    setSelectedTimeSlot(updateSelectedTimeSlot);
  };

  const handleFilter = ({ value }) => {
    setSelectedTimeSlot(null);
    setSelectedFilter(value ? value : null);
  };

  console.log("startWhen :>> ", startWhen);

  const handleGetDeviceByCampaignId = async ({ id }) => {
    try {
      console.log("id :>> ", id);
      console.log("get-device-by-campaign-id :>> ");

      const resp = await fetchAPI({
        method: "post",
        path: "/api/v1/get-device-by-campaign-id",
        isAuth: true,
        data: { campaignId: id },
      });
      const result = _.get(resp, ["result"]);
      setIsModalVisible({ isOpen: true, data: result });
      console.log("resp :>> ", resp);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const handleExportPrediction = async () => {
    await exportPrediction({ data: summaries });
  };

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents style={{ overflow: "hidden" }}>
            <SectionGroupAction>
              <Button onClick={() => navigate(-1)} padding="0px">
                <Icon
                  isCursor
                  width={14}
                  height={14}
                  style={{ marginRight: 8 }}
                >
                  <ICON_ARROW_BACK_MENU />
                </Icon>
                <Text fontSize="18px" fontWeight="600">
                  Back
                </Text>
              </Button>
              <Button
                onClick={() => handleExportPrediction()}
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                padding="7px 15px"
              >
                Export
              </Button>
            </SectionGroupAction>

            <SectionContentLayout>
              <LayoutPrediction>
                <LayoutPredictionHeader>
                  <div>
                    <Select
                      allowClear
                      size="large"
                      showSearch
                      placeholder="Select a medias"
                      optionFilterProp="children"
                      style={{ width: 200 }}
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      onChange={(value) => handleFilter({ value })}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={mediaListOptions}
                    />
                  </div>
                  Filter Prediction
                  <Slider $setMultiple={setMultiple} $multiple={multiple} />
                </LayoutPredictionHeader>

                <LayoutPredictionContent>
                  <LayoutLabelTimeSlot>
                    {_.map(labelTimeSlots, (item, index) => {
                      const duration = _.get(item, ["duration"]);
                      const label = _.get(item, ["label"]);
                      return (
                        <LabelTimeSlotItem
                          key={index}
                          $width={duration * multiple}
                        >
                          <Text fontSize="14px" fontWeight="400">
                            {label}
                          </Text>
                        </LabelTimeSlotItem>
                      );
                    })}
                  </LayoutLabelTimeSlot>
                  {_.map(renderTimeSlots, (blockItem, blockIndex) => {
                    const timeSlot = _.get(blockItem, ["timeSlot"]);
                    return (
                      <ContainerBlockList key={blockIndex}>
                        <ContainerBlockLabel>
                          <Text fontSize="14px" color={COLOR_BLACK}>
                            {`Block-${blockIndex + 1}`}
                          </Text>
                        </ContainerBlockLabel>

                        <CampaignListBlock key={blockIndex}>
                          {_.map(timeSlot, (item, index) => {
                            const duration = _.get(item, ["duration"]);
                            const type = _.get(item, ["type"]);
                            const isActive =
                              _.get(item, ["nanoId"]) ===
                              _.get(selectedTimeSlot, ["nanoId"]);

                            const isHightLight = !selectedFilter
                              ? true
                              : selectedFilter === _.get(item, ["mediaName"]);
                            return (
                              <CampaignItem
                                disabled={!isHightLight}
                                onClick={() => handleSelectTimeSlot({ item })}
                                key={`${blockIndex}-${index}`}
                                $width={duration * multiple}
                                style={{
                                  background: isHightLight
                                    ? _.get(MAPPING_COLORS, [type])
                                    : "#ffffff",
                                  opacity: isActive ? 0.4 : 1,
                                }}
                              />
                            );
                          })}
                        </CampaignListBlock>
                      </ContainerBlockList>
                    );
                  })}
                </LayoutPredictionContent>
              </LayoutPrediction>
              <ContainerLayoutSummary>
                <PopoverItem
                  $item={selectedTimeSlot}
                  $handleGetDeviceByCampaignId={handleGetDeviceByCampaignId}
                />
                <LayoutSummary>
                  <Text fontSize="20px" fontWeight="600" color={COLOR_BLACK}>
                    Summary
                  </Text>
                  <SummaryTable data={summaries} />
                </LayoutSummary>
              </ContainerLayoutSummary>
            </SectionContentLayout>
          </InnerContents>
        </Content>
      </Layout>

      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`Prediction (Media Playback Device Detection)`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() =>
          setIsModalVisible((prev) => ({ ...prev, isOpen: false }))
        }
      >
        <DeviceList data={_.get(isModalVisible, ["data", "devices"])} />
      </Modal>
    </Layout>
  );
};
